var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "omnistock omni-card"
  }, [this.$slots.header ? _c('OmniCardHeader', [_vm._t("header")], 2) : _vm._e(), this.$slots.default ? _c('OmniCardBody', [_vm._t("default")], 2) : _vm._e(), this.$slots.footer ? _c('OmniCardFooter', [_vm._t("footer")], 2) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }